import { ListingImage } from '@zoopla/listings/image';
import { SkeletonBlock, SkeletonRow, SkeletonItem } from '../Skeleton/Skeleton';
import {
    StyledCard,
    StyledLinkSkeleton,
    CardDetailsSkeleton,
    ShortSkeletonRow
} from './ListingCardPortraitSkeleton.styles';

export const ListingCardPortraitSkeleton = () => {
    return (
        <StyledLinkSkeleton data-testid="listing-card-portrait-skeleton">
            <StyledCard hasShadow={false} hasBorder hasBackground aria-hidden>
                <ListingImage useImagePlaceholder={false} />
                <CardDetailsSkeleton>
                    <SkeletonBlock>
                        <ShortSkeletonRow>
                            <SkeletonItem size={18} />
                        </ShortSkeletonRow>
                        <ShortSkeletonRow>
                            <SkeletonItem size={5} />
                            <SkeletonItem size={5} />
                            <SkeletonItem size={5} />
                        </ShortSkeletonRow>
                        <SkeletonRow>
                            <SkeletonItem size={30} />
                        </SkeletonRow>
                        <SkeletonRow>
                            <SkeletonItem size={24} />
                        </SkeletonRow>
                    </SkeletonBlock>
                </CardDetailsSkeleton>
            </StyledCard>
        </StyledLinkSkeleton>
    );
};
